/* global axios */
import ApiClient from './ApiClient';

class AnalyticsAPI extends ApiClient {
  constructor() {
    super('analytics', { accountScoped: true });
  }

  overview({ since, until } = {}) {
    return axios.get(`${this.url}/overview`, {
      params: { since, until },
    });
  }

  contacts({ since, until } = {}) {
    return axios.get(`${this.url}/contacts`, {
      params: { since, until },
    });
  }

  aiCost({ since, until } = {}) {
    return axios.get(`${this.url}/ai_cost`, {
      params: { since, until },
    });
  }

  billing({ since, until } = {}) {
    return axios.get(`${this.url}/billing`, {
      params: { since, until },
    });
  }

  exportContacts() {
    return axios.get(`${this.url}/export_contacts`);
  }
}

export default new AnalyticsAPI();
